module.exports = __webpack_public_path__ + "static/media/Menu.eb931706.svg";